import { collection, getDocs, query, where, addDoc, serverTimestamp } from 'firebase/firestore';
import { db } from '../firebase';

/**
 * Notify organization admins when a provisional license is created.
 * Creates an in-app notification for each admin of the organization.
 */
export const notifyAdminsOfProvisionalLicense = async ({
  orgId,
  orgName,
  userName,
  userId,
}) => {
  try {
    // Find all admins of this organization
    const membersRef = collection(db, 'organizations', orgId, 'members');
    const adminQuery = query(membersRef, where('role', 'in', ['Admin', 'admin', 'Creator', 'creator']));
    const adminSnap = await getDocs(adminQuery);

    const notifications = [];

    adminSnap.forEach((adminDoc) => {
      const adminUserId = adminDoc.id;
      // Create a notification in the admin's notification feed
      notifications.push(
        addDoc(collection(db, 'users', adminUserId, 'notifications'), {
          type: 'provisional_license',
          title: 'Provisional License Issued',
          message: `${userName || 'A new member'} joined your community "${orgName || 'your organization'}" on a provisional license. You have 14 days to upgrade your seats.`,
          orgId,
          userId,
          read: false,
          createdAt: serverTimestamp(),
        })
      );
    });

    await Promise.all(notifications);
  } catch (error) {
    console.warn('Failed to notify admins of provisional license:', error);
  }
};
